export default __webpack_public_path__ + "static/media/notifications_bell_grey.0180a11a.svg";